import { SettingToggle } from '@shopify/polaris'
import React from 'react'
import { useController, useFormContext } from 'react-hook-form'
import { useAccount } from '../hooks/useAccount'
import { getTranslation } from '../util/getTranslation'

export const SettingsNumericId = () => {
  const account = useAccount()
  const { setValue } = useFormContext()
  const { field } = useController({
    name: 'useNumericalId',
    defaultValue: account.segmentConfig.useNumericalId ?? false,
  })

  const contentStatus = field.value ? getTranslation('common.turn_off') : getTranslation('common.turn_on')

  return (
    <SettingToggle
      enabled={field.value}
      action={{
        content: contentStatus,
        onAction: () => setValue(field.name, !field.value),
      }}
    >
      <span>{getTranslation('settings.use_numerical_id')}</span>
    </SettingToggle>
  )
}

export default SettingsNumericId
